import { useState, useEffect } from "react";
import { leftItems, typeRightData } from "./data";

const StockTypes = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [translateYValue, setTranslateYValue] = useState(getTranslateValue());

  const handleTypes = (index) => {
    setActiveIndex(index);
  };

  function getTranslateValue() {
    if (window.innerWidth < 430) {
      return 170;
    } else if (window.innerWidth <= 375) {
      return 190;
    } else if (window.innerWidth <= 480) {
      return 150;
    } else if (window.innerWidth <= 575) {
      return 120;
    } else if (window.innerWidth <= 768) {
      return 150;
    } else if (window.innerWidth <= 991) {
      return 100;
    } else if (window.innerWidth <= 1025) {
      return 200;
    } else if (window.innerWidth <= 1250) {
      return 180;
    } else {
      return 150;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setTranslateYValue(getTranslateValue());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="row st-type-row">
        <div className="col-lg-6">
          <div className="st-type-left-wrap">
            {leftItems.map((data, index) => (
              <div
                className={`st-type-left  ${
                  activeIndex === index ? "active" : ""
                }`}
                key={index}
                onClick={() => handleTypes(index)}
              >
                <div
                  className={`st-type-left-img-wrap ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  <img
                    src={data.img}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <div className="st-width">
                  <div className="d-flex align-items-center justify-content-between st-width-gap">
                    <h6 className="st-type-left-title">{data.title}</h6>
                    <span
                      className={
                        activeIndex === index
                          ? "st-type-left-icon active"
                          : "st-type-left-icon"
                      }
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="st-type-right">
            <div
              style={{
                transform: `translateY(-${activeIndex * translateYValue}px)`,
                transition: "transform 0.5s ease-in-out",
              }}
            >
              {typeRightData.map((content, index) => (
                <div className="st-type-content-wrap" key={index}>
                  <p
                    className={`st-type-right-content ${
                      activeIndex === index ? "active" : ""
                    }`}
                  >
                    {content}
                  </p>
                </div>
              ))}
            </div>
            <div className="st-type-right-fade"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockTypes;
